export const ServiceList = [
  {
    img: "/RTAfinal.jpg",
    title: "Share Transfer Agent",
    description:
      "Acting as an intermediary between a company and its shareholders. We are responsible for handling various administrative tasks related to the ownership and transfer of shares.",
  },
  {
    img: "/Dematerialisation.jpeg",
    title: "Dematerialisation",
    description:
      "Process of converting physical securities into electronic form. This process eliminates the need for paper-based certificates and makes it easier to buy, sell, and transfer shares.",
  },
  {
    img: "/Evoting.jpeg",
    title: "E-Voting",
    description:
      "E-voting is a process which ensures faster results, increased accessibility, and can enhance voter participation while aiming to maintain vote security and integrity.",
  },
  {
    img: "/agm.jpg",
    title: "AGM/EGM/BM",
    description:
      "Video conferencing services allow real-time audio and video communication between remote participants. We conduct AGM/EGM/BM through VC.",
  },
];
